import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"
import _imports_0 from '../../../assets/img/icons/search.svg'


const _hoisted_1 = { class: "form-group mb-25" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["value"]
const _hoisted_4 = {
  key: 0,
  class: "text-muted d-block mt-2"
}
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "search-area style-two position-relative w-100 barcode-search" }
const _hoisted_7 = {
  key: 0,
  class: "barcode-search-results mt-2"
}
const _hoisted_8 = { class: "product-list-header" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "product-thumb-wrap" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "product-result-main" }
const _hoisted_13 = { class: "product-result-name" }
const _hoisted_14 = { class: "product-result-category" }
const _hoisted_15 = { class: "product-result-meta" }
const _hoisted_16 = { class: "product-result-code" }
const _hoisted_17 = { class: "product-result-price" }
const _hoisted_18 = {
  key: 0,
  class: "product-empty-state"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    class: "mb-30 choose-form",
    onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addFirstResult && _ctx.addFirstResult(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[7] || (_cache[7] = _createElementVNode("label", { class: "d-block fs-14 text-black mb-2" }, "Choose Warehouse", -1)),
      _withDirectives(_createElementVNode("select", {
        class: "bg-white border-0 rounded-1 fs-14 text-optional",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedWarehouseId) = $event)),
        disabled: _ctx.isWarehouseLocked || _ctx.loading,
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onWarehouseChange && _ctx.onWarehouseChange(...args)))
      }, [
        _cache[6] || (_cache[6] = _createElementVNode("option", { value: null }, "Choose Warehouse", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warehouses, (warehouse) => {
          return (_openBlock(), _createElementBlock("option", {
            key: warehouse.id,
            value: warehouse.id
          }, _toDisplayString(warehouse.name), 9, _hoisted_3))
        }), 128))
      ], 40, _hoisted_2), [
        [
          _vModelSelect,
          _ctx.selectedWarehouseId,
          void 0,
          { number: true }
        ]
      ]),
      (_ctx.isWarehouseLocked)
        ? (_openBlock(), _createElementBlock("small", _hoisted_4, " Warehouse is locked from the current user profile. "))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block fs-14 text-black mb-2" }, "Choose Product", -1)),
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          ref: "searchInput",
          type: "text",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.productQuery) = $event)),
          onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showResults = true)),
          onKeyup: _cache[4] || (_cache[4] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.addFirstResult && _ctx.addFirstResult(...args)), ["prevent"]), ["enter"])),
          placeholder: "Scan / Search product by code or name",
          class: "w-100 h-55 bg_ash border-0 rounded-1 fs-14 text-black bg-white pe-5",
          autocomplete: "off"
        }, null, 544), [
          [_vModelText, _ctx.productQuery]
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("button", {
          type: "button",
          class: "search-btn border-0 bg-transparent",
          tabindex: "-1",
          "aria-hidden": "true"
        }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "Search"
          })
        ], -1))
      ]),
      (_ctx.shouldShowDropdown)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", null, _toDisplayString(_ctx.wantsAllProducts ? "Available products" : "Matching products"), 1),
              _createElementVNode("small", null, _toDisplayString(_ctx.visibleProducts.length) + " item" + _toDisplayString(_ctx.visibleProducts.length === 1 ? "" : "s"), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleProducts, (product) => {
              return (_openBlock(), _createElementBlock("button", {
                key: product.id,
                type: "button",
                class: "product-result-item",
                onClick: ($event: any) => (_ctx.addProduct(product))
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("img", {
                    src: _ctx.getProductImage(product),
                    alt: "Product",
                    class: "product-thumb"
                  }, null, 8, _hoisted_11)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("strong", _hoisted_13, _toDisplayString(product.name), 1),
                  _createElementVNode("small", _hoisted_14, _toDisplayString(product.category?.name || "No Category"), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(product.code), 1),
                  _createElementVNode("span", _hoisted_17, "$" + _toDisplayString(_ctx.formatPrice(product.price)), 1)
                ])
              ], 8, _hoisted_9))
            }), 128)),
            (!_ctx.visibleProducts.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, " No products found for this warehouse. "))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 32))
}